import { type BaseQueryMeta, createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiBlobRequest } from '#shared/api/requests';
import {
    getOpenApiGetWarehouseDeliveryIntakeLabelsUrl,
    OpenApiGetWarehouseDeliveryIntakeLabelsMethod,
    type OpenApiGetWarehouseDeliveryIntakeLabelsPathParameters,
    type OpenApiGetWarehouseDeliveryIntakeLabelsSearchParams,
} from '#shared/api/schema';

export type GetWarehouseDeliveryIntakeLabelsParams = OpenApiGetWarehouseDeliveryIntakeLabelsPathParameters &
    OpenApiGetWarehouseDeliveryIntakeLabelsSearchParams;

const warehouseIntakeLabelsApi = createApi({
    name: 'entities/warehouse/api/warehouseIntakeLabels',
    baseQuery: createBaseQuery(apiBlobRequest),
    endpoints: (builder) => {
        return {
            getWarehouseDeliveryIntakeLabels: builder.query<
                { blobData: Blob; filename: string; partialSuccess: boolean },
                GetWarehouseDeliveryIntakeLabelsParams
            >({
                query: ({ warehouse_id, ...params }) => {
                    return {
                        url: getOpenApiGetWarehouseDeliveryIntakeLabelsUrl({ warehouse_id }),
                        params,
                        method: OpenApiGetWarehouseDeliveryIntakeLabelsMethod,
                    };
                },
                keepUnusedDataFor: 0,
                transformResponse: (
                    baseQueryReturnValue: Blob,
                    meta: BaseQueryMeta
                ): { blobData: Blob; filename: string; partialSuccess: boolean } => {
                    return {
                        blobData: baseQueryReturnValue,
                        filename: 'Штрихкоды доставки.zip',
                        partialSuccess: meta.response?.headers
                            ? meta.response?.headers['x-partial-success'] === 'true'
                            : false,
                    };
                },
            }),
        };
    },
});

export const getWarehouseDeliveryIntakeLabels =
    warehouseIntakeLabelsApi.endpoints.getWarehouseDeliveryIntakeLabels.query;
